import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Button } from '@udemy/react-core-components';
import { LINK_ROUTES } from '../constants';
import styles from "./unlock-button.module.css";
export const UnlockButton = ({
  size = 'medium',
  ownerName,
  onClick,
  ...props
}) => {
  const {
    gettext,
    interpolate
  } = useI18n();
  let unlockButton = {
    props: {
      href: LINK_ROUTES.buy,
      componentClass: 'a',
      className: styles['buy-button'],
      'data-testid': 'buy-button'
    },
    buttonContent: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: styles['button-text-large']
    }, gettext('Buy Udemy Business')), /*#__PURE__*/React.createElement("span", {
      className: styles['button-text-small']
    }, gettext('Buy now')))
  };
  if (ownerName) {
    const nudgeButtonMessage = gettext('Send feedback to %(owner)s');
    unlockButton = {
      props: {
        'data-testid': 'nudge-owner-button'
      },
      buttonContent: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
        className: styles['button-text-large']
      }, interpolate(nudgeButtonMessage, {
        owner: ownerName
      }, true)), /*#__PURE__*/React.createElement("span", {
        className: styles['button-text-small']
      }, gettext('Send feedback')))
    };
  }
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onClick,
    size: size,
    udStyle: "brand"
  }, unlockButton.props, props), unlockButton.buttonContent);
};
//# sourceMappingURL=unlock-button.react-component.js.map